export default __webpack_public_path__ + "static/media/Peter.f4f1b2ec.jpg";